import { Popup } from 'semantic-ui-react';

export default Popup;
